<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="题目类型:">
          <el-select v-model="listQuery.type" placeholder="请选择">
            <el-option
              v-for="(item,key) in typeValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="难度:">
          <el-select v-model="listQuery.degree" placeholder="请选择">
            <el-option
              v-for="(item,key) in degreeValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="要求度:">
          <el-select v-model="listQuery.require" placeholder="请选择">
            <el-option
              v-for="(item,key) in requireValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适应层次:">
          <el-select v-model="listQuery.lv" placeholder="请选择">
            <el-option
              v-for="(item,key) in lvValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
          <el-button type="success" size="medium" @click="handleAdd">新增</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData"  stripe style="width: 100%">
      <el-table-column prop="id" label="序号" width="50px">
      </el-table-column>
      <el-table-column prop="question" label="题目名称" width="400px">
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          {{ typeValues[scope.row.type]}}
        </template>
      </el-table-column>
      <el-table-column  label="难度">
        <template slot-scope="scope">
          {{ degreeValues[scope.row.degree]}}
        </template>
      </el-table-column>
      <el-table-column   label="要求度">
        <template slot-scope="scope">
        {{ requireValues[scope.row.require]}}
        </template>
      </el-table-column>
      <el-table-column   label="适用层次">
        <template slot-scope="scope">
        {{ lvValues[scope.row.lv]}}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
<!--          <el-button type="primary" size="mini" @click="handleStudent(scope)">预览</el-button>-->
          <el-button type="warning" size="mini" @click="handleEdit(scope)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- v-if="pageform.total>pageform.pageSize" -->

    <div style="text-align: right;margin-top:20px">

      <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.per_page"
                  @pagination="getData"/>

    </div>
    <el-dialog :title="dialogType=='new'?'新增试题':'编辑试题'" :visible.sync="dialogVisible">
      <el-form :model="question">
        <el-form-item label="题型" :label-width="formLabelWidth">
          <el-select v-model="question.type" placeholder="请选择">
            <el-option
              v-for="(item,key) in typeValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="医学题型分类" :label-width="formLabelWidth" required>
          <el-input v-model="question.category" autocomplete="off"
                    placeholder="请填写医学题型分类（A1~A4、B1、B2、X等）"></el-input>
        </el-form-item>
        <el-form-item label="分值" :label-width="formLabelWidth" required>
          <el-input v-model="question.points" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="题干" :label-width="formLabelWidth" required>
          <el-input v-model="question.question" autocomplete="off" placeholder="请填写题干"></el-input>
        </el-form-item>
        <el-form-item label="选项" :label-width="formLabelWidth" v-if="question.type==1" required>
          <div v-for="(item,index) in singleSelect">
            <el-radio v-model="singleAnswer" :label="item.answer">{{item.answer+'.'}}
              <el-input v-model="item.content" autocomplete="off" placeholder="请填选项"></el-input><i class="el-icon-delete" @click="deleteSingle(index)"></i>
            </el-radio>
          </div>
          <el-button type="primary" @click="addSingleSelect">添加选项</el-button>
        </el-form-item>
        <el-form-item label="选项" :label-width="formLabelWidth" v-if="question.type==2" required>
          <div v-for="(item,index) in manySelect">
            <el-checkbox-group v-model="manyAnswer">
              <el-checkbox  :label="item.answer">{{item.answer+'.'}}
                <el-input v-model="item.content" autocomplete="off" placeholder="请填选项"></el-input><i class="el-icon-delete" @click="deleteMany(index)"></i>
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <el-button type="primary" @click="addManySelect">添加选项</el-button>
        </el-form-item>
        <el-form-item label="选项" :label-width="formLabelWidth" v-if="question.type==3" required>
          <el-radio v-model="question.answer" label="正确"></el-radio>
          <el-radio v-model="question.answer" label="错误"></el-radio>
        </el-form-item>
        <el-form-item label="参考评分点" :label-width="formLabelWidth"  v-if="question.type!==2&&question.type!==1&&question.type!==3" required>
          <el-input type="textarea" v-model="question.answer" autocomplete="off" placeholder="请填写参考评分点，多个参考评分点请换行"></el-input>
        </el-form-item>
        <el-form-item label="考察知识模块" :label-width="formLabelWidth" required>
          <el-input v-model="question.pbase" autocomplete="off" placeholder="请填写考察知识模块"></el-input>
        </el-form-item>
        <el-form-item label="知识要点" :label-width="formLabelWidth" required>
          <el-input v-model="question.base" autocomplete="off" placeholder="请填写知识要点"></el-input>
        </el-form-item>
        <el-form-item label="答题时间" :label-width="formLabelWidth" required>
          <el-input v-model="question.times" autocomplete="off" placeholder="请填写答题时间"></el-input>
        </el-form-item>
        <el-form-item label="区分度" :label-width="formLabelWidth" required>
          <el-input v-model="question.separate" autocomplete="off" placeholder="请填写区分度"></el-input>
        </el-form-item>
        <el-form-item label="认知" :label-width="formLabelWidth" required>
          <el-select v-model="question.cognition" placeholder="请选择">
            <el-option
              v-for="(item,key) in cognitionValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题源" :label-width="formLabelWidth" required>
          <el-select v-model="question.source" placeholder="请选择">
            <el-option
              v-for="(item,key) in sourceValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="适用层次" :label-width="formLabelWidth" required>
          <el-select v-model="question.lv" placeholder="请选择">
            <el-option
              v-for="(item,key) in lvValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="要求度" :label-width="formLabelWidth" required>
          <el-select v-model="question.require" placeholder="请选择">
            <el-option
              v-for="(item,key) in requireValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="难度" :label-width="formLabelWidth" required>
          <el-select v-model="question.degree" placeholder="请选择">
            <el-option
              v-for="(item,key) in degreeValues"
              :key="key"
              :label="item"
              :value="key">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="pushQuestion()">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
    import Pagination from '../../components/Pagination'

    export default {
        components: {Pagination},
        props: {},
        data() {
            return {
                formLabelWidth:'15%',
                theory: {},
                question: {},
                teacherList: [],
                testList: [],
                typeValues:{},
                degreeValues:{},
                requireValues:{},
                sourceValues:{},
                cognitionValues:{},
                lvValues:{},
                total: 0,
                dialogVisible: false,
                dialogType: 'new',
                listQuery: {
                    page: 1,
                    per_page: 20,
                },
                tableData: []
            };
        },
        computed: {},
        created() {
            this.getData();
        },
        methods: {

            deleteSingle(index){
                this.singleSelect.splice(index,1)
                this.singleSelect.forEach((value,index) => {
                    value.answer=Select[index]
                })
            },
            deleteMany(index){
                this.manySelect.splice(index-1,1)
                this.manySelect.forEach((value,index) => {
                    value.answer=Select[index]
                })
            },
            addSingleSelect() {
                if (this.singleSelect.length>14)
                {
                    this.$message.error('选项过多！')
                    return false;
                }
                const answer = Select[this.singleSelect.length];
                this.singleSelect.push({
                    answer: answer,
                    content: ''
                })
            },
            addManySelect() {
                if (this.manySelect.length>14)
                {
                    this.$message.error('选项过多！')
                    return false;
                }
                const answer = Select[this.manySelect.length];
                this.manySelect.push({
                    answer: answer,
                    content: ''
                })
            },
            search() {
                this.listQuery.page = 1;
                this.getData()
            },
            pushQuestion(){

            },
            showName(value) {
                if (value == 0) {
                    this.nameShow = 1
                } else {
                    this.nameShow = 0
                }
            },
            // 获取全部的课程列表
            getData() {
                this.$http.getQuestionList(this.listQuery)
                    .then(res => {
                        this.tableData = res.data;
                        this.typeValues = res.typeValues;
                        this.degreeValues = res.degreeValues;
                        this.requireValues = res.requireValues;
                        this.cognitionValues = res.cognitionValues;
                        this.sourceValues = res.sourceValues;
                        this.lvValues = res.lvValues;
                        this.total = res.meta.total;
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleAdd() {
                this.question = {};
                this.dialogType='new';
                this.dialogVisible = true
            },
            handleStudent(scope) {
                this.$router.push({name:'studentManage',query:{id:scope.row.id}})
            },
            handleEdit(scope) {
                this.dialogType='edit';
                this.dialogVisible = true;
                this.$http.getViewQuestion(scope.row.id).then(res => {
                    this.question = res.data
                })
            },
            confirmSave() {
                const isEdit = this.dialogType === 'edit'
                if (isEdit) {
                    this.$http.updateTheory(this.theory.id, this.theory).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        });
                        this.getData()
                    })
                } else {
                    this.$http.addTheory(this.theory).then(res => {
                        this.dialogVisible = false
                        this.$notify({
                            title: 'Success',
                            message: '操作成功！',
                            type: 'success'
                        })
                        this.getData()
                    })
                }
            },
            handleDelete({$index, row}) {
                this.$confirm('确定要删除此条吗?', '警告', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                    .then(() => {
                        this.$http.deleteTheory(row.id).then(res => {
                            this.tableData.splice($index, 1)
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            })
                        });

                    })
                    .catch(err => {
                        console.error(err)
                    })
            },
        },
    };
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/page/theoryManage/theoryQuestions.vue